const authActionTypes = {
  LOG_IN_START: 'LOG_IN_START',
  REFRESH_USER: 'REFRESH_USER',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  LOG_IN_FAILURE: 'LOG_IN_FAILURE',
  REGISTER_START: 'REGISTER_START',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE',
  LOG_OUT: 'LOG_OUT',
  EMAIL_VERIFY: 'EMAIL_VERIFY',
  SEND_2FA_CODE: 'SEND_2FA_CODE',
  UPDATE_AUTH: 'UPDATE_AUTH',
  VERIFY_2FA_CODE: 'VERIFY_2FA_CODE',
  USER_VERIFY_RESPONSE: 'USER_VERIFY_RESPONSE',
  CHECK_INVITE_TOKEN: 'CHECK_INVITE_TOKEN',
  ACCEPT_INVITE: 'ACCEPT_INVITE',
  ACCEPT_INVITE_RESULT: 'ACCEPT_INVITE_RESULT',
  CLEAR_ACCEPT_INVITE_RESULT: 'CLEAR_ACCEPT_INVITE_RESULT',
  SEND_DECLINE_REASON: 'SEND_DECLINE_REASON',
  SAVE_PROFILE: 'SAVE_PROFILE',
  SEND_RESET_EMAIL: 'SEND_RESET_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_RESULT: 'RESET_RESULT',
  FIND_INVITE: 'FIND_INVITE',
  SET_INVITE_DATA: 'SET_INVITE_DATA',
  SET_AUTH_LOADING: 'SET_AUTH_LOADING',
  SET_AUTH_ERROR: 'SET_AUTH_ERROR',
  SET_USER_THEME: 'SET_USER_THEME',
  MFA_UPDATE_RESULT: 'MFA_UPDATE_RESULT',
  MFA_SENT: 'MFA_SENT',
  GET_CAPTCHA_STATUS: 'GET_CAPTCHA_STATUS',
  SET_CAPTCHA_REQUIRED: 'SET_CAPTCHA_REQUIRED',
  SET_COLLAPSED: 'SET_COLLAPSED',
};

export default authActionTypes;
